






import { defineComponent, computed } from '@nuxtjs/composition-api'
import { ProductStatus } from '@/types/product/productTypes'
import { PRODUCT_STATUS } from '@/common/utils/product/constants'

export default defineComponent({
  props: {
    productStatus: {
      type: String as () => ProductStatus,
      required: true,
    },
  },
  setup(props) {
    const getStatusColorClass = computed(() => {
      switch (props.productStatus) {
        case PRODUCT_STATUS.DISCONTINUED: {
          return 'error'
        }
        case PRODUCT_STATUS.RELEASED_ON_HOLD: {
          return 'info'
        }
        case PRODUCT_STATUS.PENDING:
        case PRODUCT_STATUS.PRE_DISCONTINUED:
        case PRODUCT_STATUS.PRE_RELEASED: {
          return 'warning'
        }
      }
    })
    const getStatusText = computed(() => {
      if (props.productStatus === PRODUCT_STATUS.DISCONTINUED) {
        return `This product is discontinued`
      }
      if (props.productStatus === PRODUCT_STATUS.RELEASED_ON_HOLD) {
        return `Product on Backorder – Available Within 30 Days`
      }
      if (props.productStatus === PRODUCT_STATUS.PENDING) {
        return `This product is currently unavailable`
      }
      if (props.productStatus === PRODUCT_STATUS.PRE_DISCONTINUED) {
        return `This product is going to be discontinued in the near future. <a href="/learn-and-support/support-information">CST Technical Support</a> is happy to discuss alternatives.`
      }
      if (props.productStatus === PRODUCT_STATUS.PRE_RELEASED) {
        return `This product will be available within 5-7 business days.`
      }
    })

    const displayCondition = computed(() => {
      return (
        props.productStatus === PRODUCT_STATUS.DISCONTINUED ||
        props.productStatus === PRODUCT_STATUS.RELEASED_ON_HOLD ||
        props.productStatus === PRODUCT_STATUS.PENDING ||
        props.productStatus === PRODUCT_STATUS.PRE_DISCONTINUED ||
        props.productStatus === PRODUCT_STATUS.PRE_RELEASED
      )
    })
    return { getStatusColorClass, getStatusText, displayCondition }
  },
})
